<script>
/*jshint esversion: 6 */ 
import {watch, computed, inject} from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";
export default {
    name: 'FurtherEmail',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers' : FontAwesomeLayers,
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep:true});


        function addJob() {
            props.model[props.schema.model].push('');
        }

        function deleteJob(index) {
            props.model[props.schema.model].splice(index,1);
        }

        return {
            addJob, 
            deleteJob, 
        }
    }
}
</script>
<template lang="pug">
.vueFormFieldMain
    .myFurtherEmail(
        :class="schema.class"
    )
        label(v-if="schema.label && schema.label.length > 0") {{ schema.label }}
        .furtherMailMain.mt-4(
            :style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''"
        ) 
            template(v-for="item, index in model[schema.model]")
                .row.align-items-start
                    .row.align-items-start
                        .row.justify-content-between 
                            .col-9 
                                label {{ index+1 }}. E-Mail-Adresse
                                span.redAst(v-if="index === 0") *
                            .col-1.plusButton(
                                v-if="(index+1 === model[schema.model].length) && (item !== '')"
                                @click="addJob(index)")
                                .row.align-items-end.justify-content-end
                                    .col-2
                                        font-awesome-layers.fa-lg.setPlus
                                            font-awesome-icon(icon="fa-solid fa-plus"  transform="shrink-7")
                                            font-awesome-icon(icon="fa-regular fa-circle")
                            .col-1.minusButton(@click="deleteJob(index)" v-if="index > 0")
                                .row.align-items-end.justify-content-end
                                    .col-2
                                        font-awesome-layers.fa-lg.setMinus
                                            font-awesome-icon(icon="fa-solid fa-minus"  transform="shrink-7")
                                            font-awesome-icon(icon="fa-regular fa-circle")
                        .cols-12.fieldInput
                            input.form-control(
                                :id="`email${index}`" 
                                type="text" 
                                :name="`email${index}`" 
                                :value="model[schema.model][index]" 
                                v-model="model[schema.model][index]" 
                                :style="disabled === true ? 'pointer-events:none': ''"
                            )
                br
            .form-group.row.gy-2.gx-3-align-items-left
                .vueFormSmall.labelred(v-if="schema.errorShow === true")
                    font-awesome-icon(icon="fa-solid fa-exclamation" class="redAst") 
                    | &nbsp;{{ schema.errorText[0] }}
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
</template>
    
        